export default () => {
    return {
        show: false,
        animating: false,

        open() {
            this.show = true;
            this.animating = true;

            const openPopup = gsap.timeline({
                onComplete: () => {
                    this.animating = false;
                }
            });

            openPopup
                .fromTo(this.$refs.background, { opacity: 0 }, { duration: 0.5, opacity: 0.8, delay: 0.2 })
                .fromTo(
                    this.$refs.contentBase,
                    { yPercent: 101 },
                    { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                    '<'
                );

            if (this.$refs.media) {
                openPopup
                    .fromTo(
                        this.$refs.curtain,
                        { yPercent: -101 },
                        { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                        '<'
                    )
                    .set(this.$refs.media, { opacity: 1 })
                    .to(this.$refs.curtain, { duration: 0.5, yPercent: 101, ease: 'circ.inOut' });
            }

            if (this.$refs.icon) {
                openPopup.from(this.$refs.icon, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.subheadline) {
                openPopup.from(this.$refs.subheadline, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.headline) {
                openPopup.from(this.$refs.headline, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.text) {
                openPopup.from(this.$refs.text, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.buttons) {
                openPopup.from(this.$refs.buttons, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.emailCapture) {
                openPopup.from(this.$refs.emailCapture, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            openPopup.from(this.$refs.close, { duration: 0.3, yPercent: -100, opacity: 0 }, '>-0.2');
        },

        close() {
            this.animating = true;

            const closePopup = gsap.timeline({
                onComplete: () => {
                    this.animating = false;
                    this.show = false;
                }
            });

            closePopup.to(this.$refs.close, { duration: 0.3, opacity: 0 });

            if (this.$refs.icon) {
                closePopup.to(this.$refs.icon, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.subheadline) {
                closePopup.to(this.$refs.subheadline, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.headline) {
                closePopup.to(this.$refs.headline, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.text) {
                closePopup.to(this.$refs.text, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.buttons) {
                closePopup.to(this.$refs.buttons, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.emailCapture) {
                closePopup.to(this.$refs.emailCapture, { duration: 0.3, opacity: 0 }, '>-0.2');
            }

            if (this.$refs.media) {
                closePopup
                    .fromTo(
                        this.$refs.curtain,
                        { yPercent: -101 },
                        { duration: 0.3, yPercent: 0, ease: 'circ.inOut' },
                        '<'
                    )
                    .set(this.$refs.media, { opacity: 0 })
                    .to(this.$refs.curtain, { duration: 0.3, yPercent: 101, ease: 'circ.inOut' });
            }

            closePopup
                .to(this.$refs.contentBase, { duration: 0.4, yPercent: -101, ease: 'circ.inOut' }, '<')
                .to(this.$refs.background, { duration: 0.5, opacity: 0 });
        }
    };
};
